import * as React from "react";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../../DataClasses/GenericUser";
import {
    Theme,
    WithStyles,
    createStyles,
    withStyles,
} from "@material-ui/core/styles";
import idssStyle from "../../../Configuration/SharedStyling";
import { connect } from "react-redux";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, Grid, IconButton, Tooltip, Typography } from "@material-ui/core";
import { ISubOrgVendor } from "../../../DataClasses/SubOrgVendor"; 
import MUIDataTable, { MUIDataTableColumn, MUIDataTableOptions } from "mui-datatables";
import { Redirect } from "react-router-dom";
import AdministrationService from "../../Services/AdministrationService";
import { AjaxError } from "rxjs/ajax";
import { InfoOutlined } from "@material-ui/icons";
import { firstValueFrom } from 'rxjs';
import LoadingDataTable from "../../Shared/LoadingDataTable";
import { SeedTime } from "../../../Configuration/Setting";

const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    paperStyle: {
        flexGrow: 1,
        padding: theme.spacing(2, 2),
    }
});
interface LocalProps {
    productYear: number
}
interface IVendorOrgMapStateStore {
    isLoading: boolean;
    showInvalidOnly: boolean;
    redirect: boolean,
    mappingData: ISubOrgVendor[],
    tableData: ISubOrgVendor[],
    showHedis: boolean,
    showCahps: boolean,
    showHos: boolean,
    openReadMe: boolean
}

type Props = LocalProps & WithStyles<typeof styles>;

const SubIdColumnRender = ({ value, tableMeta }) => {
    return (
        <Tooltip title="Click to visit the Submission Page">
            <a href={'/submissionHome/' + value + '/' + tableMeta.rowData[2].replace("HEDIS", "DST") + '/' + tableMeta.rowData[3]}>{value}</a>
        </Tooltip>
    );
}
class VendorOrgMapView extends React.Component<
    IGenericUserProps & Props,
    IVendorOrgMapStateStore
    > {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            showInvalidOnly: false,
            redirect: false,
            mappingData: [],
            tableData: [],
            showCahps: false,
            showHedis: true,
            showHos: false,
            openReadMe: false
        }
    }

    public componentDidMount() {
        this.refreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;
        const mtOptions: MUIDataTableOptions = {
            filter: true,
            filterType: "dropdown",
            print: false,
            download: true,
            selectableRows: "none",           
        };

        return <Grid container alignItems="flex-end" spacing={2} className={ classes.root}>
                <Grid item={true} xs={3}>
                    <Typography variant='h6' color='primary' className={classes.tabTitle}>
                    Mapping List
                    <Tooltip title="How does this page work?">
                        <IconButton onClick={() => this.setState({ openReadMe: true })}>
                            <InfoOutlined />
                        </IconButton>
                    </Tooltip>
                    </Typography>
                <Dialog
                        open={this.state.openReadMe}
                        onClose={() => this.setState({ openReadMe: false })}
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle>{"How does this page work?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                            A submission is considered to have valid sub-org-vendor mapping if it satisfies the following criteria:<br />
                                <ul>
                                    <li> <b>Organization Mapping</b>: Each submission must have an OrgID that matches a valid OrgName in the Data Warehouse (DW).</li>
                                    <li> <b>HEDIS Submissions</b>: For submissions related to DST (HEDIS), there must be a software VendorID that corresponds to a valid OrgName in DW.</li>
                                    <li> <b>CAHPS or HOS Submissions</b>: For CAHPS or HOS submissions, a ComponentVendorID with an accurate OrgName mapping in DW is required.</li>
                                    <li> <b>Audit Firm Mapping (HEDIS/CAHPS)</b>: If a submission has AuditRequired as Yes, there must be a AuditFirmId that corresponds to a valid OrgName in DW.</li>
                                </ul>
                            If a submission does not meet the specified criteria, it will be <span style={{ backgroundColor: 'yellow' }}>highlighted in yellow</span> in the table. If the "Display only invalid mappings" option is checked, the table will show only the submissions that violate the specified criteria.<br />
                            The table offers filters to display only HEDIS, CAHPS, or HOS submissions as needed.<br />
                            Software Vendors are associated with HEDIS submissions, and Component Vendors with CAHPS and HOS submissions. Therefore:<br />
                            <ul>
                                <li>Selecting only HEDIS will only display Software Vendor IDs and Names while hiding Component Vendor information.</li>
                                <li>Selecting only CAHPS or/and HOS will display only Component Vendor IDs and Names.</li>
                            </ul>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={() => this.setState({ openReadMe: false })}>CLOSE</Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
                <Grid item={true} xs={3}>
                    <Checkbox
                        checked={this.state.showInvalidOnly}
                        onChange={() => {
                            this.setState({
                                showInvalidOnly: !this.state.showInvalidOnly
                            }, () => {
                                this.PopulateTableData()
                            });
                        }}
                        color="primary"
                    />
                    <small><strong>Display only invalid mappings</strong></small>
                </Grid>
                <Grid item={true} xs={6}>
                    Type(s) to View:
                    <Checkbox
                        checked={this.state.showHedis}
                        onChange={() => {
                            this.setState({
                                showHedis: !this.state.showHedis
                            }, () => {
                                this.PopulateTableData()
                            });
                        }}
                        color="primary"
                    />
                    <small><strong>HEDIS</strong></small>
                    <Checkbox
                        checked={this.state.showCahps}
                        onChange={() => {
                            this.setState({
                                showCahps: !this.state.showCahps
                            }, () => {
                                this.PopulateTableData()
                            });
                        }}
                        color="primary"
                    />
                    <small><strong>CAHPS</strong></small>
                    <Checkbox
                        checked={this.state.showHos}
                        onChange={() => {
                            this.setState({
                                showHos: !this.state.showHos
                            }, () => {
                                this.PopulateTableData()
                            });
                        }}
                        color="primary"
                    />
                    <small><strong>HOS</strong></small>
                </Grid>
                {this.state.isLoading ? (
                    <LoadingDataTable titleText={"*"} />
                ) : (
                    <Fade in={true} {...{ timeout: SeedTime }}>
                <div style={{width: '100%'}}>
                <Grid item={true} xs={12}>
                    <MUIDataTable
                        title={""}
                        data={this.state.tableData}
                        columns={this.getMappingTableColumns()}
                        options={mtOptions}
                    />
                </Grid>
                </div>
                </Fade>
                )}
        </Grid>
    }

    private getMappingTableColumns = () => {
        const renderSubIdColumn = (value, tableMeta, updateValue) => {
            return <SubIdColumnRender value={value} tableMeta={tableMeta} />;
        };

        let retval: MUIDataTableColumn[] = [
            {
                name: "isValid",
                label: "Valid",
                options: {
                    display: false
                }
            },
            {
                name: "submissionId",
                label: "SubID",
                options: {
                    customBodyRender: renderSubIdColumn
                }
            }, 
            {
                name: "component",
                label:"Component"
            },
            {
                name: "productLine",
                label: "ProductLine"
            },
            {
                name: "orgId",
                label: "OrgID",
                options: {
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta)
                }
            },
            {
                name: "orgName",
                label: "OrgName",
                options: {
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta)
                }
            },
            {
                name: "softwareVendorId",
                label: "SoftwareVendorId",
                options: {
                    display: this.state.showHedis,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isHedisColumn: true })
                }
            },
            {
                name: "softwareVendorName",
                label: "SoftwareVendorName",
                options: {
                    display: this.state.showHedis,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isHedisColumn: true })
                }
            },
            {
                name: "componentVendorId",
                label: "ComponentVendorId",
                options: {
                    display: this.state.showCahps || this.state.showHos,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isNonHedisColumn: true })
                }
            },
            {
                name: "componentVendorName",
                label: "ComponentVendorName",
                options: {
                    display: this.state.showCahps || this.state.showHos,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isNonHedisColumn: true })
                }
            },
            {
                name: "isAuditRequired",
                label: "AuditRequired",
                options: {
                    display: this.state.showHedis || this.state.showCahps
                }
            },
            {
                name: "auditFirmId",
                label: "AuditFirmId",
                options: {
                    display: this.state.showHedis || this.state.showCahps,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isAuditColumn: true })
                }
            },
            {
                name: "auditFirmName",
                label: "AuditFirmName",
                options: {
                    display: this.state.showHedis || this.state.showCahps,
                    customBodyRender: (value, tableMeta) => this.renderColumn(value, tableMeta, { isAuditColumn: true })
                }
            }  
        ];
        return retval;
    }

    private renderColumn(value, tableMeta,
        options: { isHedisColumn?: boolean; isNonHedisColumn?: boolean; isAuditColumn?: boolean; auditIndex?: number; hedisIndex?: number }
            = { isHedisColumn: false, isNonHedisColumn: false, isAuditColumn: false, auditIndex: 10, hedisIndex: 2 }) {
        const {
            isHedisColumn = false,
            isNonHedisColumn = false,
            isAuditColumn = false,
            auditIndex = 10,
            hedisIndex = 2
        } = options;

        let isInvalidValue = (value === null || value.length === 0 || value <= 0);
        const isHedis = (tableMeta.rowData[hedisIndex] === 'HEDIS');
        if (isHedisColumn) {
            isInvalidValue = isHedis && isInvalidValue;
        } else if (isNonHedisColumn) {
            isInvalidValue = !isHedis && isInvalidValue;
        } else if (isAuditColumn) {
            const isAuditRequired = (tableMeta.rowData[auditIndex] === 'Yes');
            isInvalidValue = isAuditRequired && isInvalidValue;
        } 

        const style = isInvalidValue ? { backgroundColor: 'yellow', padding: '8px' } : { padding: '8px' };
        return <div style={style}>{value}</div>;
    }


    private async refreshModel() {
        this.setState({ isLoading: true });

        const retval: ISubOrgVendor[] = await firstValueFrom(
            AdministrationService.GetSubOrgVendorMap$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        }
        else {
            this.setState({
                mappingData: retval
            });
        }
        this.PopulateTableData();
        this.setState({ isLoading: false });
    }

    private PopulateTableData = () => {
        let tableData: ISubOrgVendor[] = [];
        this.state.mappingData.forEach((item) => {
            let showBasedOnInvalidOnlySelection = this.state.showInvalidOnly? !item.isValid : true;
            if (showBasedOnInvalidOnlySelection && this.state.showHedis && item.component === "HEDIS") {
                tableData.push(item);
            }
            if (showBasedOnInvalidOnlySelection && this.state.showCahps && item.component.includes("CAHPS")) {
                tableData.push(item);
            }
            if (showBasedOnInvalidOnlySelection && this.state.showHos && item.component === "HOS") {
                tableData.push(item);
            }
        });
        this.setState({
            tableData: tableData
        });
    }
}

const VendorOrgMapPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(VendorOrgMapView);

// STYLES CONTAINER
const VendorOrgMapPage = withStyles(styles)(
    VendorOrgMapPageWithState
);

export default VendorOrgMapPage;